import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';

export function DashboardLayout() {
  return (
    <>
      <TopBar />
      <Outlet />
    </>
  );
}
